import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useSimsStore = create()(
    persist(
        (set) => ({
            refetchSimCards: false,
            storeRefetchSimCards: (refetchSimCards) => set(() => ({ refetchSimCards: refetchSimCards })),
            refetchSimCardsFromModal: false,
            storeRefetchSimCardsFromModal: (refetchSimCardsFromModal) => set(() => ({ refetchSimCardsFromModal: refetchSimCardsFromModal })),
            querySimCards: getInitialQuery(),
            storeQuerySimCards: (querySimCards) => set(() => ({ querySimCards: querySimCards })),

            refetchSimGroups: false,
            storeRefetchSimGroups: (refetchSimGroups) => set(() => ({ refetchSimGroups: refetchSimGroups })),
            querySimGroups: getInitialQuery(),
            storeQuerySimGroups: (querySimGroups) => set(() => ({ querySimGroups: querySimGroups }))
        }),
        {
            name: 'sims-storage'
        }
    )
);

export default useSimsStore;